import { selfAxios } from "../../../../../axios/selfAxios.js";
async function opPostGetProductionOrderPromotionTypeInfoByServiceId(params) {
  const res = await selfAxios.post(`/designordercenter/productionOrder/rule/getProductionOrderPromotionTypeInfoByServiceId`, params);
  return res.data;
}
export { opPostGetProductionOrderPromotionTypeInfoByServiceId };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designordercenter/productionOrder/rule/getProductionOrderPromotionTypeInfoByServiceId/post.js